import styled from 'styled-components';

export const Wrapper = styled.div`
  .muiTabs {
    div[class^='MuiTabs-scrollable'], div[class*=' MuiTabs-scrollable'] {
      overflow-x: hidden;
    }
  }
`;
